/**
 * Project : workspace
 * File    : AppConfig.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package appConfig

import com.parmartechnologies.app.composeapp.generated.resources.Res
import com.parmartechnologies.business.feature.business.handler.BusinessHandler
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.business.feature.businessConfig.viewModel.BusinessConfigViewModel
import com.parmartechnologies.core.constant.AppServer
import com.parmartechnologies.core.constant.Environment
import com.parmartechnologies.core.feature.auth.model.BusinessConstants
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.core.navigation.NavigationParam
import com.parmartechnologies.storage.constant.KeyConstant
import com.parmartechnologies.storage.store.UserDefaults
import generated.BuildFlavor
import graph.AppType
import graph.PlatformType
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import navigation.AppNavigator
import theme.ThemeColor

/**
 * Represents the app config class.
 */

class AppConfig {
    val version = "1.0.0"
    private val decoder = Json {
        encodeDefaults = true
        ignoreUnknownKeys = true
        isLenient = true
    }
    val scope = CoroutineScope(Job() + Dispatchers.Default)
    var appName = "Mandee"
    val countryCode = "IN"
    var currency = "INR"
    var currencySymbol = "₹"
    var business: Business? = null
    var appType = AppType.BUSINESS
    var platformType = PlatformType.Mobile
    var platform = PlatformType.Android
    var domainUrl = "https://mandee.ai"

    init {
        instance = this
    }

    companion object {
        private var instance: AppConfig? = null

        /**
         * Executes the shared operation.
         *
         * @receiver TODO
         * @return The resulting app config.
         */
        fun shared(): AppConfig {
            if (instance != null) {
                return instance as AppConfig
            } else {
                return AppConfig()
            }
        }
    }

    /**
     * Executes the set domain operation.
     *
     * @receiver TODO
     * @return Unit – no return value.
     */

    fun setDomain() {

        if (BuildFlavor.FLAVOR == "prod") {
            AppServer.shared().setup(Environment.prod)
//            AppServer.shared().setupFor("https://f944-2401-4900-b488-1a69-50b3-6c61-c314-7aeb.ngrok-free.app")
        } else if (BuildFlavor.FLAVOR == "qa") {
            AppServer.shared().setup(Environment.qa)
//            AppServer.shared().setupFor("https://f944-2401-4900-b488-1a69-50b3-6c61-c314-7aeb.ngrok-free.app")
        } else {
            AppServer.shared()
                .setupFor("https://f944-2401-4900-b488-1a69-50b3-6c61-c314-7aeb.ngrok-free.app")
        }
    }

    /**
     * Executes the set business operation.
     *
     * @receiver TODO
     * @return Unit – no return value.
     */
    fun setBusiness() {
        setDomain()
        val myBusiness = UserDefaults.shared().retrieve(KeyConstant.myBusiness)
        if (appType != AppType.BUSINESS && BusinessConstants().selectedBusiness.isNotBlank()) {
            business = decoder.decodeFromString(BusinessConstants().selectedBusiness)
            scope.launch {
                BusinessHandler.shared().repository.myBusinessLiveData.emit(business!!)
                delay(500)
                BusinessConfigViewModel().fetchBusinessConfig()
            }
            ThemeColor.shared().applyCustomTheme()
//            MediaFileViewModel().retrieve()
        } else {
            if (myBusiness.isNotEmpty()) {
                try {
                    business = decoder.decodeFromString(myBusiness)
                    CoroutineScope(Job() + Dispatchers.Default).launch {
                        BusinessHandler.shared().repository.myBusinessLiveData.emit(business!!)
                        delay(500)
                        BusinessConfigViewModel().fetchBusinessConfig()
                    }
                } catch (e: Exception) {
                    print(e.message)
                }

            }
        }
    }

    /**
     * Executes the set business for custom app operation.
     *
     * @receiver TODO
     * @return Unit – no return value.
     */

    fun setBusinessForCustomApp() {
        setDomain()
        scope.launch {
            val businessStr = Res.readBytes("files/selected_business.json").decodeToString()
            business = decoder.decodeFromString(businessStr)
            val navParams = NavigationParam()
            navParams._id = business?._id ?: ""
            AppNavigator.shared().setParam("store/details", navParams)
            delay(500)
            BusinessConfigViewModel().fetchBusinessConfig()
            BusinessViewModel().loadBusinessById(navParams._id)
        }
    }

    /**
     * Executes the get selected business from json operation.
     *
     * @receiver TODO
     * @param callBack The call back.
     * @return Unit – no return value.
     */

    fun getSelectedBusinessFromJson(callBack: (Business) -> Unit) {
        scope.launch {
            val businessStr = Res.readBytes("files/selected_business.json").decodeToString()
            business = decoder.decodeFromString(businessStr)
            callBack(business!!)
        }
    }
}